"use client";

import { PAYMENT_ICONS } from "./paymentIcons";

const THEME_FOOTER = {
  background: "#000000",
  text: "#ffffff",
  textMuted: "rgba(255,255,255,0.8)",
  fontBody: '"Avenir Next", Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  maxWidth: 1600,
  paddingHorizontal: 40,
  paddingTop: 40,
  paddingBottom: 24,
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61552184746005",
    instagram: "https://www.instagram.com/recruit_gfx/",
  },
};

function FacebookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}
function InstagramIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  );
}

// Laid out as the store's footer: social icons centred, payment icons under
// them, the copyright line at the bottom left.
export default function StoreFooter() {
  const T = THEME_FOOTER;
  const base = (process.env.NEXT_PUBLIC_STORE_URL || "https://recruitgraphics.com").replace(/\/$/, "");

  return (
    <footer
      style={{
        backgroundColor: T.background,
        color: T.textMuted,
        padding: `${T.paddingTop}px ${T.paddingHorizontal}px ${T.paddingBottom}px`,
        fontFamily: T.fontBody,
        marginTop: "auto",
      }}
    >
      <style>{`@media (max-width: 749px) { .rg-footer-copy { text-align: center; } }`}</style>
      <div style={{ maxWidth: T.maxWidth, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 24, marginBottom: 40 }}>
          <a href={T.social.facebook} style={{ color: T.text }} aria-label="Facebook">
            <FacebookIcon />
          </a>
          <a href={T.social.instagram} style={{ color: T.text }} aria-label="Instagram">
            <InstagramIcon />
          </a>
        </div>
        <ul style={{ listStyle: "none", margin: "0 0 14px", padding: 0, display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10 }}>
          {PAYMENT_ICONS.map(([name, svg]) => (
            <li key={name} style={{ display: "flex" }} dangerouslySetInnerHTML={{ __html: svg }} />
          ))}
        </ul>
        <div className="rg-footer-copy" style={{ fontSize: 11, letterSpacing: "0.6px" }}>
          © {new Date().getFullYear()}, <a href={base} style={{ color: T.textMuted, textDecoration: "none" }}>Recruit Graphics</a>
        </div>
      </div>
    </footer>
  );
}
